import React from 'react';
import { Input, Button, Select, Viewer, Modal, Pagination, Tooltip, DatePicker, PaperClip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { connect } from 'react-redux';
import { EditIcon, AlertIcon, SettingIcon, Menu as MenuIcons, AlertCircleIcon, Upload3Icon, UploadCircle } from 'assets/icons';
import moment from 'moment';
import { CompanyService, ReportService } from 'services';
import ModalCompanies from './modal-companies';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class UploadBills extends React.Component<Props> {

	state = {
		form: {
			company_id: -1
		},
		companies: [],
		default_company: null,
		name: '',
		items: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Cargar facturas',
				onBack: null,
				subtitle: 'Sube tus facturas para que sean procesadas automáticamente.',
				color: '#edf0fe',
				icon: MenuIcons.Menu6
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await CompanyService.admin.get({
			withoutLoading
		});
		this.setState({
			companies: res.companies || [],
			default_company: res.default_company,
			form: {
				...this.state.form,
				company_id: res.companies?.find((i: any) => i.id == this.state.form.company_id) != null ? this.state.form.company_id : -1
			}
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	upload = (e: any, name = '') => {
	    let company_id = this.state.form.company_id || '';
	    if (company_id == -1) {
	        company_id = '';
	    }

	    const newFileName = name;
	    const newFileDate = moment().format('DD/MM/YYYY HH:mm');
	    
	    const tempId = Math.random().toString(36).substr(2, 9) + Date.now();

	    this.setState((prevState: any) => {
	        const updatedItems = [...(prevState.items || [])];
	        updatedItems.push({
	            id: tempId,
	            name: newFileName,
	            date: newFileDate,
	            verification_id: null
	        });
	        return { items: updatedItems };
	    }, async () => {	        
	        const res: any = await ReportService.admin.bills.upload({
	            hasFile: true,
	            file: e.target?.value,
	            company_id,
	            withoutLoading: true
	        });

	        if (res && res.verification_id) {
	            this.setState((prevState: any) => {
	                const updatedItems = prevState.items.map((item: any) => {
	                    if (item.id === tempId) {
	                        return {
	                            ...item,
	                            verification_id: res.verification_id
	                        };
	                    }
	                    return item;
	                });
	                return { items: updatedItems };
	            });
	        }
	    });
	}

	render() {
		const { items } = this.state;

		return (
			<div id="upload-bills">
				<div className="container-white">
					{
						this.state.companies?.length > 0 && (
							<div className="row">
								<div className="col-md-3">
									<div className="container-companies">
										<Select
											color="white"
											placeholder="Seleccionar"
											label="Empresa"
											name="company_id"
											onChange={ (e: any) => this.change(e) }
											value={ this.state.form.company_id }
											options={ [
												// @ts-ignore
												{ value: -1, label: (this.state.default_company?.name || '') + ' ' + (this.state.default_company?.lastname || '') },
												...this.state.companies.map((item: any) => {
													return {
														value: item.id,
														label: item?.name
													}
												})
											] } />
									</div>
								</div>
							</div>
						)
					}
					<div className="text-center">
						<PaperClip
							formats={['png', 'jpg', 'jpeg','pdf']}
							value={''}
							multiple={ true }
							onChange={(e: any) => {
								this.upload(e,e.target?.original_name || 'Archivo');
							}}>
							<img className="upload-circle" src={ UploadCircle } />
							<p className="bold">Arrastra tus facturas aquí</p>
							<p>O haz clic para seleccionar archivos</p>
							<div className="container-formats">
								<p>Formatos permitidos: JPG, PNG, PDF • Tamaño máximo: 10 MB</p>
							</div>
							<div className="text-center">
								<div className="container-icon">
									<img src={ Upload3Icon } />
									<p>Seleccionar archivos</p>
								</div>
							</div>
						</PaperClip>
					</div>
					{
						items?.map((item: any) => {
							return (
								<div className="container-upload">
									<div className="row align-items-center">
										<div className="col-md">
											<div className="container-name">
												<div className="container-icon">
													<img src={ MenuIcons.Menu5 } />
												</div>
												<p>{ item?.name }</p>
											</div>
										</div>
										<div className="col-md">
											<div className="container-loading">
												{
													!item?.verification_id && (
														<div className="loader"></div>
													)
												}
												<p className={ item?.verification_id ? 'completed' : '' }>{ item?.verification_id ? 'Completado' : 'Procesando...' }</p>
											</div>
										</div>
										<div className="col-md text-right">
											{
												item?.verification_id && (
													<Link to={ ((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/bills/report/view/' + item?.verification_id } target="_blank">
														<button className="btn btn-view">
															Ver resultado
														</button>
													</Link>
												)
											}
											<p className="date">{ item?.date }</p>
										</div>
									</div>
								</div>
							)
						})
					}
					<div className="important-container">
						<img src={ AlertCircleIcon } />
						<div>
							<p className="bold">Información importante</p>
							<p>Asegúrate de que las facturas sean legibles y contengan todos los datos fiscales.</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(UploadBills);